<template>
  <div>
    <header class="modal-header">
      <h3 class="modal-title">{{mode + ' User Account'}}</h3>
    </header>
    <div class="modal-body">
      <b-form>
        <b-row>
          <b-col md="6">
            <b-form-group
              label="USERNAME:"
              label-for="username">
              <b-form-input
                id="username"
                placeholder="User email"
                type="text"
                v-model="userAccount.USER_NAME"
                :disabled="mode === 'Edit'">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="FULL NAME:"
              label-for="fullName">
              <b-form-input
                id="fullName"
                type="text"
                v-model="userAccount.FULL_NAME"
                required>
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        
        <b-row align-v="center">
          <b-col sm="6">
            <b-form-group
              label="User Module:"
              label-for="userService">
              <multiselect
                id="userService"
                v-model="selectedModule"
                :options="userServiceModules"
                group-values="module"
                group-label="serviceName"
                track-by="moduleName"
                label="moduleName"
                :option-height="30"
                placeholder="Select Module"
                required
                @select="selectedRole = undefined" />
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              label="User Role:"
              label-for="userRole">
              <div class="d-flex align-items-center">
                <multiselect
                  id="userRole"
                  v-model="selectedRole"
                  :options="getModuleRoles"
                  placeholder="Select User Role"
                  track-by="CODE"
                  label="NAME"
                  required
                  class="mr-2" />
                <b-btn
                  size="sm"
                  variant="success"
                  :disabled="!selectedModule || !selectedRole"
                  @click="addModule">
                  <i class="fa fa-plus" />
                </b-btn>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="mb-2">
          <b-button
            v-for="(module, idx) in modules"
            :key="idx"
            size="sm"
            pill
            variant="secondary"
            class="mr-1 mb-1"
            @click="modules.splice(idx, 1)">
            {{ `${module.moduleName} (${module.roleName})` }}
            <i class="fa fa-close" />
          </b-button>
        </div>
        <b-form-group
          label="STATUS:"
          label-for="status">
          <c-switch
            color="success"
            variant="pill"
            size="lg"
            v-model="userAccount.STATUS" />
        </b-form-group>
      </b-form>
    </div>
    <footer class="modal-footer">
      <b-btn :size="'sm'" @click="$emit('close')">Cancel</b-btn>
      <b-btn :variant="'primary'" :size="'sm'" @click="handleSubmit" :disabled="btnDisabled">{{mode === 'Add' ? 'Add' : 'Update'}}</b-btn>
    </footer>
  </div>
</template>
<script>
import { Switch as cSwitch } from '@coreui/vue'
import Multiselect from 'vue-multiselect'
import server from '@/services/server'
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'
import groupBy from 'lodash/groupBy'

export default {
  name: 'user-accounts-modal',
  props: {
    mode: String,
    model: Object
  },
  data () {
    return {
      selectedModule: undefined,
      selectedRole: undefined,
      modules: [],
      userModules: [],
      userAccount: {
        USER_NAME: '',
        FULL_NAME: '',
        PARTNER_API_KEY: '',
        USER_SERVICE_CODE: [],
        USER_ROLE_CODE: '',
        AVAILABILITY_START_DATE: moment().format('YYYY-MM-DD'),
        AVAILABILITY_END_DATE: moment().add(2, 'y').format('YYYY-MM-DD'),
        STATUS: false
      },
      isFetching: false,
      selectedServices: []
    }
  },
  created () {
    if (this.mode === 'Edit') {
      this.userAccount = {...this.model}
      this.modules = this.transformServiceCode(this.model.USER_SERVICE_CODE)
      let profile = this.getByUACode(this.model.CODE)
      this.userAccount.FULL_NAME = `${profile.FIRST_NAME} ${profile.LAST_NAME}`
      this.userAccount.STATUS = this.userAccount.STATUS > 0 ? true : false
    }
    this.getUserServices()
    this.getUserRoles()
  },
  computed: {
    getStatus () {
      if (this.userAccount) {
        return this.userAccount.STATUS ? true : false
      } else {
        return false
      }
    },
    ...mapGetters('userProfile', [
      'getByUACode',
    ]),
    ...mapState('userService', {
      userServices: state => state.items
    }),
    ...mapState('userRole', {
      userRoles: state => state.items
    }),
    getModuleRoles () {
      if (!this.selectedModule) return []
      return this.$store.getters['userRole/getModuleRoles'](this.selectedModule.moduleName)
    },
    userServiceModules () {
      return this.$store.getters['userService/getServiceModules']
    },
    btnDisabled () {
      return !this.userAccount.USER_NAME || !this.userAccount.FULL_NAME ||
        !this.modules.length
    }
  },
  components: {
    cSwitch,
    Multiselect
  },
  methods: {
    transformServiceCode (serviceCode) {
      let arr = []
      serviceCode.forEach((service) => {
        const tmp = service.USER_MODULE.map((module) => {
          return {
            roleName: module.USER_ROLE_NAME,
            roleCode: this.userRoles.find(o => o.NAME === module.USER_ROLE_NAME).CODE,
            moduleName: module.MODULE_NAME,
            serviceCode: service.SERVICE_CODE
          }
        })
        arr = [...arr, ...tmp]
      })
      return arr
    },
    addModule () {
      const tmp = {
        roleCode: this.selectedRole.CODE,
        roleName: this.selectedRole.NAME,
        ...this.selectedModule
      }
      if (!this.modules.find(o => o.moduleName === tmp.moduleName && o.serviceCode === tmp.serviceCode)) {
        this.modules.push(tmp)
      }
      this.selectedModule = undefined
      this.selectedRole = undefined
    },
    handleSubmit (e) {
      e.preventDefault()
      this.isFetching = true
      const serviceTmp = groupBy(this.modules, 'serviceCode')
      const userServiceCode = Object.keys(serviceTmp).map((o) => {
        return {
          serviceCode: o,
          userModule: serviceTmp[o].map((service) => {
            return {
              moduleName: service.moduleName,
              userRoleCode: service.roleCode
            }
          })
        }
      })
      let payload = {
        uaCode: this.userAccount.CODE,
        userName: this.userAccount.USER_NAME,
        fullName: this.userAccount.FULL_NAME,
        partnerApiKey: this.userAccount.PARTNER_API_KEY,
        userServiceCode: userServiceCode,
        status: this.userAccount.STATUS ? 1 : 0
      }
      if (this.mode === 'Add') {
        payload.availabilityStartDate = moment().format('YYYY-MM-DD'),
        payload.availabilityEndDate = moment().add(2, 'y').format('YYYY-MM-DD')
      } else {
        payload.uaCode = this.userAccount.CODE
        payload.availabilityStartDate = this.userAccount.AVAILABILITY_START_DATE
        payload.availabilityEndDate = this.userAccount.AVAILABILITY_END_DATE
        payload.status = this.userAccount.STATUS ? 1 : 0
      }

      if (this.mode === 'Add') {
        this.isFetching = true
        this.$store.dispatch('userAccount/addEmployee', [payload]).then(
          _ => this.$emit('close')
        )
      } else {
        this.$store.dispatch('userAccount/updateEmployee', [payload]).then(
          _ => this.$emit('close')
        )
      }
    },
    getUserServices () {
      if (this.mode === 'Edit') {
        this.userAccount.USER_SERVICE_CODE = this.userServices.filter(userService => this.userAccount.USER_SERVICE_CODE.includes(userService.CODE))
      }
    },
    getUserRoles () {
      if (this.mode === 'Edit') {
        this.userAccount.USER_ROLE_CODE = this.userRoles.find(role => role.CODE === this.userAccount.USER_ROLE_CODE)
      }
    },
    generateApiKey () {
      let payload = [{ userName: this.userAccount.USER_NAME}]
      server.post('/generatePartnerApiKey', payload).then( resp => {
        let apiKey = resp.data.msgContent.partnerApiKey
        this.userAccount.PARTNER_API_KEY = apiKey
      })
    }
  }
}
</script>
